module.exports = __webpack_public_path__ + "static/img/irole.035d6da.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/tsz/irole.png
// module id = 3Xam
// module chunks = 7